const createToggleFavoriteReducer = (reducerName, initialState) =>
  (state = { ...initialState }, action) => {
    switch (action.type) {
      case `${reducerName}_TOGGLE_FAVORITE`:
        return { ...state, loading: true };

      case `${reducerName}_TOGGLE_FAVORITE_SUCCESS`: {
        const { report_type, is_favorite } = action.payload;

        const updatedReports = state.data.map(report =>
          report.report_type === report_type
            ? { ...report, is_favorite }
            : report
        );

        return { ...state, loading: false, data: updatedReports };
      }

      case `${reducerName}_TOGGLE_FAVORITE_FAILURE`:
        return { ...state, loading: false };

      default:
        return state;
    }
  };

export default createToggleFavoriteReducer;
